import Vue from "vue";
import Vuex from "vuex";

// Modules
import app from "./app";
import appConfig from "./app-config";
import verticalMenu from "./vertical-menu";
import shared from "../modules/shared/store";
import account from "../modules/account/store";
import contract from "../modules/contract/store";
import contract_closing from "../modules/contract_closing/store";
import snapshot_change from "../modules/snapshot_change/store";
import product from "../modules/product/store";
import financial_solution from "../modules/financial_solution/store";
import partner_company from "../modules/partner_company/store";
import kpi from "../modules/kpi/store";
import consultant from "../modules/consultant/store";
import notification from "../modules/notification/store";
import report from "../modules/report/store";
import lead from "../modules/lead/store";
import franchises from "../modules/franchises/store";
import profile from "../modules/profile/store";
import customer from "../modules/customer/store";
import appointment from "../modules/appointment/store";
import system from "../modules/system/store";
import commission from "../modules/commission/store";
import withdrawal from "../modules/withdrawal/store";
import financial_adjustment from "../modules/financial_adjustment/store";
import financial_batch from "../modules/financial_batch/store";
import financial_management from "../modules/financial_management/store";
import todo from "../modules/todo/store";
import dashboard from "../modules/dashboard/store";
import nps from "../modules/nps/store";
import support_ticket from "../modules/support_ticket/store";
import accounting_management from "../modules/accounting_management/store";
import access_management from "../modules/access_management/store";
import financial_planning from "../modules/financial_planning/store";
import recruitment from "../modules/recruitment/store";
import discount_coupon from "../modules/discount_coupon/store";
import franchise_manual from "../modules/franchise_manual/store";
import promotion from "../modules/promotion/store";
import okr from "../modules/okr/store";
import certificate from "../modules/certificate/store";
import copilot_audit from "../modules/copilot_audit/store";
import specialist_vertical from "../modules/specialist_vertical/store";
import plan_implementation from "../modules/plan_implementation/store";
import whatsNew from "../modules/whats-new/store";
import customerChat from '../modules/customer_chat/store'
import customerChatPlugin from '../modules/customer_chat/store/plugin'

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    app,
    appConfig,
    verticalMenu,
    shared,
    account,
    contract,
    contract_closing,
    snapshot_change,
    product,
    financial_solution,
    partner_company,
    kpi,
    consultant,
    notification,
    report,
    lead,
    profile,
    customer,
    appointment,
    system,
    commission,
    withdrawal,
    financial_adjustment,
    financial_batch,
    financial_management,
    franchises,
    dashboard,
    todo,
    nps,
    support_ticket,
    accounting_management,
    support_ticket,
    access_management,
    financial_planning,
    recruitment,
    discount_coupon,
    franchise_manual,
    promotion,
    okr,
    certificate,
    copilot_audit,
    specialist_vertical,
    plan_implementation,
    whatsNew,
    customer_chat: customerChat,
  },
  plugins: [customerChatPlugin],
});
